import React from 'react';
import Disclaimer from 'components/common/general/Disclaimer';
import { createStyles } from '../../globalStyles';
import RateSegmentsContent from '../../components/rate-segments/RateSegmentsContent/index';

const RateSegmentsPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={classes.widePageWrapper}>
      <RateSegmentsContent />
      <Disclaimer />
    </div>
  );
};

export default RateSegmentsPage;
